import { FC } from "react";

interface Props {
  filled?: boolean;
  onClick: (e: any) => void;
  tabIndex: number;
  ariaLabel: string;
  isCheckbox?: boolean;
}

export const Star: FC<Props> = ({
  filled,
  onClick,
  tabIndex,
  ariaLabel,
  isCheckbox,
}) => {
  const colors = filled
    ? { fill: "#FF3D9A", stroke: "#FF3D9A" }
    : { fill: "white", stroke: "#B2B5B7" };

  return (
    <svg
      aria-label={ariaLabel}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      onKeyPress={(e) => e.key === "Enter" && onClick(e)}
      tabIndex={tabIndex}
      role="checkbox"
      {...(isCheckbox && { role: "checkbox", "aria-checked": filled || false })}
    >
      <path
        className="favorite-star"
        {...colors}
        d="M12.456 6.454C12.5652 6.67514 12.7761 6.82848 13.0201 6.86415L18.3454 7.64252C18.3768 7.64711 18.4028 7.66911 18.4126 7.69928C18.4224 7.72944 18.4142 7.76255 18.3915 7.78468L14.5388 11.5372C14.3619 11.7095 14.2812 11.9578 14.3229 12.2012L15.2321 17.5026C15.2375 17.5338 15.2246 17.5654 15.199 17.5841C15.1733 17.6027 15.1393 17.6052 15.1112 17.5904L10.3491 15.086C10.1306 14.9711 9.86945 14.9711 9.65092 15.086L4.88879 17.5904C4.86072 17.6052 4.82669 17.6027 4.80103 17.5841C4.77536 17.5654 4.76251 17.5338 4.76787 17.5026L5.67711 12.2012C5.71885 11.9578 5.63811 11.7095 5.4612 11.5372L1.60853 7.78468C1.58581 7.76255 1.57762 7.72944 1.5874 7.69928C1.59718 7.66911 1.62324 7.64711 1.65462 7.64252L6.97992 6.86415C7.22394 6.82848 7.43483 6.67514 7.54398 6.454L9.92528 1.62976C9.93932 1.60132 9.96829 1.58331 10 1.58331C10.0317 1.58331 10.0607 1.60132 10.0747 1.62976L10.7473 1.29779L10.0747 1.62976L12.456 6.454Z"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
